import React from "react"
import { ResponsiveHero } from "../../../ui/organisms/Hero/ResponsiveHero"
import { CustomContainer } from "../../../ui/spacings"
import { toHeroProps } from "../../editorialPage/converters/hero"

interface Props {
  contents: any
}

const BrandPageIntro = ({ contents }: Props) => {
  return (
    <>
      {contents.ref?.brand?.data?.banner && (
        <CustomContainer className="mb-4 sm:mt-8">
          <ResponsiveHero {...toHeroProps(contents.ref.brand.data.banner)} />
        </CustomContainer>
      )}
    </>
  )
}

export default BrandPageIntro
